// extracted by mini-css-extract-plugin
module.exports = {"title":"title-2TfQU","modal":"modal-2TpIk"};